// extracted by mini-css-extract-plugin
export var intro = "intro-module--intro--3Bcry";
export var intro__wrap = "intro-module--intro__wrap--okkUC";
export var intro__section = "intro-module--intro__section--2so-o";
export var intro__section__image = "intro-module--intro__section__image--37E1p";
export var info__section__image__bg = "intro-module--info__section__image__bg--2nzKi";
export var intro__section__image__bg = "intro-module--intro__section__image__bg--1wX-3";